.page {
  padding: var(--space-4, 1rem);
  max-width: 32rem;
  margin: 0 auto;
}

.lede {
  color: var(--muted);
  font-size: var(--text-min-body, 0.875rem);
  margin: 0 0 1.25rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.actions {
  margin-top: 0.25rem;
}

.error {
  color: var(--stop);
  font-size: var(--text-min-body, 0.875rem);
  margin: 0;
}
